// extracted by mini-css-extract-plugin
export default {"gradientText":"TestRoutes_gradientText__N7UKD","translucentBox":"TestRoutes_translucentBox__C0dJN"};